import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

interface ExportTask {
  id: string
  name: string
  apiEndpoint: string
  jobId: string | null
  status: 'loading' | 'success' | 'error'
  url: string | null
  toastId: string | number
  body?: any
}

export const exportTasksAtom = atomWithStorage<ExportTask[]>('export-tasks', [])

export const addExportTaskAtom = atom(
  null,
  (get, set, task: Omit<ExportTask, 'id'>) => {
    const id = `export_${Date.now()}`
    const newTask: ExportTask = { ...task, id }
    set(exportTasksAtom, [...get(exportTasksAtom), newTask])
    return id
  }
)

export const updateExportTaskAtom = atom(
  null,
  (get, set, { id, updates }: { id: string; updates: Partial<ExportTask> }) => {
    set(
      exportTasksAtom,
      get(exportTasksAtom).map(task =>
        task.id === id ? { ...task, ...updates } : task
      )
    )
  }
)

export const removeExportTaskAtom = atom(null, (get, set, id: string) => {
  set(
    exportTasksAtom,
    get(exportTasksAtom).filter(task => task.id !== id)
  )
})

export const loadingTasksAtom = atom(get =>
  get(exportTasksAtom).filter(task => task.status === 'loading')
)
